import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";

export default function MenuDropDownButton({ children, menuList, ...props }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="menu-dropdown-button"
        aria-controls={open ? "menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        {...props}
      >
        {children}
      </Button>
      {menuList && (
        <Menu
          id="menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              "aria-labelledby": "menu-dropdown-button",
            },
          }}
          {...menuList.props}
        >
          {menuList.menuListItems.map((menuItem, index) => {
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  if (menuItem.onClick) {
                    menuItem.onClick();
                  }
                  handleClose();
                }}
                {...menuItem.props}
              >
                {menuItem.name}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </div>
  );
}
